import React, { useCallback, useRef, useState } from "react";
import {
  TextField,
  makeStyles,
  createStyles,
  Button,
  Typography,
  Fab,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";

import AlertDialog from "../common/AlertDialog";
import Loading from "../common/Loading";
import { forgotPassword } from "../../helper/Api";
import KeyIcon from "@material-ui/icons/Lock";
import ErrorDialog from "../common/ErrorDialog";
import { errors, getApiError } from "../../helper/Error";

// CSSスタイルを定義
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "calc(100vh - 58px)", // topbarの高さ分を引く(progressBar込み)
      [`${theme.breakpoints.up("xs")} and (orientation: landscape)`]: {
        minHeight: "calc(100vh - 50px)",
      },
      [theme.breakpoints.up("sm")]: {
        minHeight: "calc(100vh - 66px)",
      },
    },
    icon: {
      marginBottom: theme.spacing(5),
    },
    title: {
      marginBottom: theme.spacing(1),
    },
    text: {
      marginBottom: theme.spacing(4),
      width: "75%",
      maxWidth: "350px",
      fontSize: 18,
    },
    email: {
      marginBottom: theme.spacing(5),
      width: "75%",
      maxWidth: "350px",
    },
    button: {
      width: "75%",
      maxWidth: "350px",
    },
  })
);

export default function Forgot() {
  const classes = useStyles();
  const history = useHistory();

  const emailRef = useRef("");
  const handleChangeEmail = useCallback((e) => {
    emailRef.current = e.target.value;
  }, []);

  const handleClickButton = useCallback(async () => {
    setIsSubmitting(true);

    await forgotPassword(emailRef.current)
      .then((res) => {
        if (res.data.error.length === 0) {
          setIsOpenResult(true);
        } else throw res.data.error;
      })
      .catch((err) => {
        errorRef.current = err.code
          ? getApiError(err)
          : errors.APP_CONNECTION_FAILED;

        setIsOpenError(true);
      });

    setIsSubmitting(false);
  }, []);

  const [isOpenResult, setIsOpenResult] = useState(false);
  const [isOpenError, setIsOpenError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const errorRef = useRef({});

  const handleCloseResult = useCallback(() => {
    setIsOpenResult(false);

    // メール送信後はログイン画面へ遷移
    history.push("/login");
  }, [history]);

  const handleCloseError = useCallback(() => {
    setIsOpenError(false);
  }, []);

  return (
    <>
      <div className={classes.root}>
        <Fab
          className={classes.icon}
          color="primary"
          disableFocusRipple
          disableRipple
        >
          <KeyIcon />
        </Fab>

        <Typography variant="h6" className={classes.title}>
          パスワード再設定
        </Typography>

        <Typography className={classes.text} color="textSecondary">
          登録しているメールアドレスを入力してください
        </Typography>

        <TextField
          label="メールアドレス"
          type="email"
          className={classes.email}
          onChange={handleChangeEmail}
        />

        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={handleClickButton}
        >
          送信
        </Button>
      </div>

      <AlertDialog open={isOpenResult} onClose={handleCloseResult}>
        正常に送信されました
      </AlertDialog>

      <ErrorDialog
        open={isOpenError}
        onClose={handleCloseError}
        error={errorRef.current}
      />

      <Loading open={isSubmitting} />
    </>
  );
}
